import { render, staticRenderFns } from "./NccSwitcher.vue?vue&type=template&id=34522c59&scoped=true&"
import script from "./NccSwitcher.vue?vue&type=script&lang=js&"
export * from "./NccSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./NccSwitcher.vue?vue&type=style&index=0&id=34522c59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34522c59",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/staging.newcitycatechismus.nl/httpdocs/web/app/themes/wp-subsite-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34522c59')) {
      api.createRecord('34522c59', component.options)
    } else {
      api.reload('34522c59', component.options)
    }
    module.hot.accept("./NccSwitcher.vue?vue&type=template&id=34522c59&scoped=true&", function () {
      api.rerender('34522c59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/QNA/NccSwitcher.vue"
export default component.exports